import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'wre-maintenancepage',
  templateUrl: './maintenancepage.component.html',
  styleUrls: ['./maintenancepage.component.sass']
})
export class MaintenancepageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
